<template>
    <!--
    作者：bbc_team
    时间：2023-06-08
    描述：插件中心-积分商城-商品设置-添加商品-商品信息
  -->
    <div>
        <div class="common-form">商品信息</div>
        <el-form-item label="活动名称">
            <p class="fb">{{ form.active_name }}</p>
        </el-form-item>
        <el-form-item label="商品名称">
            <p class="fb">{{ form.goods_name }}</p>
        </el-form-item>
        <el-form-item label="商品图片"><img :src="form.goods_image" width="80"/></el-form-item>
    </div>
</template>

<script>
    export default {
        inject: ["form"],
        data() {
            return {};
        },
        created() {}
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/activity/seckill/part/Info.vue